import { Fragment, useRef, useState } from 'react'
import type { ingredient } from '../../../../utils/ingredientUtils'

import './NewRecipeIngredient.scss'
import { getMessage } from '../../../../utils/messageUtils'

interface NewRecipeIngredientProps {
  existingIngredients: ingredient[]
  newRecipeIngredient: (productId: number, productName: string) => void
}

function NewRecipeIngredient({
  existingIngredients,
  newRecipeIngredient,
}: NewRecipeIngredientProps) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [creatingNew, setCreatingNew] = useState(false)

  const handleNewIngredient = (
    newIngredientId: string,
    newIngredientName: string
  ) => {
    if (newIngredientId.trim() === '') return

    setCreatingNew(false)

    newRecipeIngredient(Number(newIngredientId), newIngredientName)

    // Scroll to bottom after adding new ingredient
    setTimeout(() => {
      if (containerRef.current) {
        const scrollableParent = containerRef.current.closest(
          '.collapsible-section-content'
        )
        if (scrollableParent) {
          scrollableParent.scrollTop = scrollableParent.scrollHeight
        }
      }
    }, 0)
  }

  return (
    <Fragment>
      {creatingNew && (
        <select
          className="new-recipe-ingredient-select recipe-list-item"
          onChange={e =>
            handleNewIngredient(
              e.target.value,
              e.target.options[e.target.selectedIndex].text
            )
          }
        >
          <option value="">{getMessage('ingredient_select')}</option>
          {existingIngredients.map((ingredient, index) => (
            <option key={index} value={ingredient.id}>
              {ingredient.name}
            </option>
          ))}
        </select>
      )}
      {!creatingNew && (
        <div className="new-recipe-list-item" ref={containerRef}>
          {!creatingNew && (
            <button
              className="new-recipe-list-item-add-button"
              onClick={() => setCreatingNew(true)}
            >
              +
            </button>
          )}
        </div>
      )}
    </Fragment>
  )
}

export default NewRecipeIngredient
